import { TaskName } from "../mock/MockData";

export const getTaskNameFromPipeline = (pipelineName: string): TaskName | null => {
  const mapping: { [key: string]: TaskName } = {
    'CalculateUsage': TaskName.CalculateUsage,
    'RecalculatingEstimates': TaskName.RecalculatingEstimates,
    'EstimatingUsage': TaskName.EstimatingUsage,
    'Withdrawal': TaskName.Withdrawal,
    'Passthrough': TaskName.Passthrough,
    'ParseXmltoDB': TaskName.ParseXmltoDB,
    'DayAheadParseCsv': TaskName.DayAheadParseCsv,
    'EstimatingUsageParallel' : TaskName.EstimatingUsageParallel
  };
  
  return mapping[pipelineName] ?? null;
};